import BelowTheFold from 'shared/components/BelowTheFoldControl';
import React from 'react';
import loadableVisibility from 'react-loadable-visibility/loadable-components';
import AnimatedLoader from 'shared/components/BelowTheFoldControl/AnimatedLoader';
import styled from '@emotion/styled';
import { REVIEW_SECTION_ID } from 'shared/constants/productPage';


const Loading = styled(AnimatedLoader)`
  height: 450px;
`;


const Loadable = loadableVisibility(
  () => import(/* webpackChunkName: "product.btf.review" */'./Loadable'),
  {
    fallback: <Loading className="client" id={REVIEW_SECTION_ID}/>,
  },
);

const ServerOptimized = (props: any) =>
  (
    <BelowTheFold
      render={() => <Loadable {...props} />}
      loading={() => <Loading />}
    />
  )
;


export default ServerOptimized;
